export default __webpack_public_path__ + "static/media/base-background-image.4ab56f0d.jpg";